import { createAction, props } from '@ngrx/store';

export const setLanguagePrefrence = createAction(
  '[User] Set language preference',
  props<{ languageCode: string }>(),
);
export const setLanguagePrefrenceFail = createAction(
  '[User] Set language preference fail',
);
